import StandsGlobalTableFilter from "./stands-global-table-filter";

const StandsGlobalFilters = {
    Table: StandsGlobalTableFilter,
}

export default StandsGlobalFilters;
